// extracted by mini-css-extract-plugin
module.exports = {"meta":"C0DOAj7I","categoryLink":"_1o5dNvU8"};